import CryptoJS from 'crypto-js';

// Generate a random nonce for each login attempt
export const generateNonce = () => {
  // Use CryptoJS for better compatibility
  const randomBytes = CryptoJS.lib.WordArray.random(16);
  return randomBytes.toString(CryptoJS.enc.Hex);
};

// Simple XOR encryption that matches Django backend exactly
export const encryptPassword = (password, clientNonce, serverNonce) => {
  try {
    // Combine nonces and salt (matches Django backend)
    const combinedNonce = clientNonce + serverNonce;
    const salt = 'checkstall_salt';
    const keyString = combinedNonce + salt;
    
    // Generate key using SHA256 (matches Django hashlib.sha256)
    const keyHash = CryptoJS.SHA256(keyString);
    const keyBytes = keyHash.toString(CryptoJS.enc.Hex);
    
    // Use TextEncoder for correct UTF-8 encoding
    const encoder = new TextEncoder();
    const passwordArray = encoder.encode(password);
    
    // Add padding (PKCS7-like, matches Django)
    const blockSize = 16;
    const paddingLength = blockSize - (passwordArray.length % blockSize);
    const padding = new Uint8Array(paddingLength);
    padding.fill(paddingLength);
    
    // Create padded data
    const paddedData = new Uint8Array(passwordArray.length + paddingLength);
    paddedData.set(passwordArray);
    paddedData.set(padding, passwordArray.length);
    
    // Convert key to bytes
    const keyArray = new Uint8Array(keyBytes.length / 2);
    for (let i = 0; i < keyBytes.length; i += 2) {
      keyArray[i / 2] = parseInt(keyBytes.substr(i, 2), 16);
    }
    
    // XOR encryption (matches Django exactly)
    const encrypted = new Uint8Array(paddedData.length);
    for (let i = 0; i < paddedData.length; i++) {
      encrypted[i] = paddedData[i] ^ keyArray[i % keyArray.length];
    }
    
    // Convert to base64 (matches Django base64.b64encode)
    return btoa(String.fromCharCode(...encrypted));
  } catch (error) {
    console.error('Encryption error:', error);
    throw new Error('Failed to encrypt password');
  }
};

// Generate timestamp for replay attack prevention
export const generateTimestamp = () => {
  return Math.floor(Date.now() / 1000);
};

// Validate timestamp (5 minutes tolerance)
export const validateTimestamp = (timestamp) => {
  const currentTime = Math.floor(Date.now() / 1000);
  return Math.abs(currentTime - timestamp) <= 300; // 5 minutes
}; 